// tslint:disable max-line-length
import React, { useEffect, useState } from 'react';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { useParams } from 'react-router-dom';
import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import { setProfilePoint } from '../../../requests/profilepic';
import { fetchMandarinModule } from '../../../helpers/MandarinData';
import { getItem } from '../../../utils/localStorage';
import { AppHeader } from '../../../app/common/sharedComponents/AppHeader';
import {
  Wrapper,
  Content,
  VideoInformation,
  VideoSection,
  VideoSectionModule,
  VideoSectionLabel,
  VideoSectionText,
  HeaderContainer,
} from './Mandarin.styled';

const TrainingVideoList = () => {
  const [videoData, setVideoData] = useState<any>(null);
  const { id: moduleId } = useParams();
  const selectedBrand = parseInt(getItem('selectedBrand'));
  // tslint:disable-next-line:triple-equals
  const Title = selectedBrand == 26 ? 'MO Training' : 'EI Behavioral Standard';
  let stopProgressbar = false;
  useEffect(() => {
    (async () => {
      setVideoData(null);
      const data = fetchMandarinModule(moduleId);
      setVideoData(data);
    })();
  }, [moduleId]);
  const handleProgress = (e) => {
    if (isNaN(e.target.duration)) {
      return;
    }
    const progress = (e.target.currentTime / e.target.duration) * 100;

    if (progress >= 80 && !stopProgressbar) {
      const data = {
        entityId: videoData.id,
        entityType: 'Video',
        activityType: 'VideoPoint',
      };
      stopProgressbar = true;
      setProfilePoint(data)
        .then((res) => {
        })
        .catch((err) => (stopProgressbar = false));
    }
  };
  return (
    <Wrapper>
      <HeaderContainer>
        <AppHeader title={Title} hasBackButton={true} />
      </HeaderContainer>
      {!videoData ? (
        <LoadingContent layout="flex" />
      ) : (
        <Content>
          <VideoSection>
            <Video
              height={281}
              controls={['PlayPause', 'Time', 'Volume', 'Fullscreen']}
              poster={videoData.pictureUrl}
              src={videoData.videoUrl}
              type="video/mp4"
              onTimeUpdate={handleProgress}
            />
          </VideoSection>
          <VideoInformation>
            <VideoSectionModule>{videoData.module}</VideoSectionModule>
            <VideoSectionLabel>{videoData.label}</VideoSectionLabel>
            <VideoSectionText>
              Welcome to the Mandarin Oriental Training video series. Here you
              will find in depth guidance on how to deliver Legendary Quality
              Experience to our guests and our colleagues.
            </VideoSectionText>
          </VideoInformation>
        </Content>
      )}
    </Wrapper>
  );
};

export default TrainingVideoList;
